import { FC } from "react";
import "./CSS/FAQDetailScreen.css";
import backIcon from "../../assets/images/back-icon.svg";
import { useNavigate } from "react-router-dom";
import FAQExpandableSection from "./Views/FAQExpandableSection";
import ROUTE_PATHS from "utils/routePaths";
import { WEB_LINK } from "utils/strings";

const FAQDetailScreen: FC = () => {
  const navigate = useNavigate();

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  const handlePolicyClick = () => {
    navigate(ROUTE_PATHS.WSM_WEB_LINK_DETAIL, {
      state: {
        anyData: {
          title: "Privacy Policy",
          url: WEB_LINK.PRIVACY_POLICY,
        },
      },
    });
  };

  const handleTermsClick = () => {
    navigate(ROUTE_PATHS.WSM_WEB_LINK_DETAIL, {
      state: {
        anyData: {
          title: "Terms and Conditions",
          url: WEB_LINK.TERM_CONDITION,
        },
      },
    });
  };

  return (
    <div className="wms-mobile-container">
      <div className="faq-detail-screen-container">
        <div className="faq-detail-header-container">
          <img
            src={backIcon}
            alt="dropdown-logo"
            className="image"
            onClick={handleBackButtonClick}
          />
          <div className="title">FAQ</div>
        </div>
        <FAQExpandableSection title="How can I become a member?">
          <div className="item-container">
            <span>
              Membership at SABEHUB is exclusive and selective. Applications
              open a few times a year to ensure quality and a great onboarding
              experience. You can apply during these periods or submit an
              application to be considered for the next round when acceptances
              are paused.
            </span>
          </div>
        </FAQExpandableSection>
        <FAQExpandableSection title="How do I apply and what is the application process like?">
          <div className="item-container">
            <span>
              Submit an Application: Fill out the form with details about your
              professional experience and motivations. This takes around 5
              minutes.
            </span>
          </div>
        </FAQExpandableSection>
        <FAQExpandableSection title="Why 4 hours Shift not 1 hour ?">
          <div className="item-container">
            <span>
              Through our research, learned 1-hour shifts aren’t highly
              Productive. 4 hours is optimal for meaningful work without
              distractions.
            </span>
          </div>
        </FAQExpandableSection>
        <FAQExpandableSection title="Why NO TALKING ?">
          <div className="item-container">
            <span>
              We’ve created a distraction-free sanctuary to help you focus,
              finish faster, and enjoy the rest of your day stress-free.
            </span>
          </div>
        </FAQExpandableSection>

        <FAQExpandableSection title="How do I take meeting ?">
          <div className="item-container">
            <span>
              Book our private meeting pods in advance for quiet, seamless calls
              without disrupting others.
            </span>
          </div>
        </FAQExpandableSection>

        <FAQExpandableSection title="Do I need to be a member to try SABEHUB ?">
          <div className="item-container">
            <span>
              Not at all ! Our cafe and events are open to everyone. However,
              our dedicated workspace is usually reserved for members to ensure
              an optimal experience.
            </span>
          </div>
        </FAQExpandableSection>

        <FAQExpandableSection title="What is your refund and cancellation policy ?">
          <div className="item-container">
            <span>
              WorkSpace Cancellation, Refunds, Wallet Policy:{" "}
              <button onClick={handlePolicyClick}>Click Here</button>
              <br />
              WorkSpace Terms and Conditions:{" "}
              <button onClick={handleTermsClick}>Click Here</button>
            </span>
          </div>
        </FAQExpandableSection>

        <FAQExpandableSection title="What is speciality coffee?">
          <div className="item-container">
            <span>
              Specialty coffee is made from high-quality beans that are
              carefully sourced, processed, and brewed to highlight their unique
              flavors. Unlike commercial coffee, like Starbucks, which uses
              lower-grade beans and focuses on consistency and long shelf life,
              specialty coffee offers a richer and more complex flavor
              experience.
            </span>
          </div>
        </FAQExpandableSection>

        <FAQExpandableSection title="Do you sell other drinks or just coffee?">
          <div className="item-container">
            <span>
              Aside from our specialty coffee, we also offer premium matcha
              sourced from Japan and a variety of naturally made kombuchas in
              different flavors. Both options not only taste amazing but also
              provide excellent health benefits.
            </span>
          </div>
        </FAQExpandableSection>
      </div>
    </div>
  );
};

export default FAQDetailScreen;
